import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 24a.818.818 0 110-1.636c5.724 0 10.364-4.64 10.364-10.364 0-5.724-4.64-10.364-10.364-10.364C6.276 1.636 1.636 6.276 1.636 12c0 1.204.206 2.38.602 3.49a.818.818 0 01-1.54.55A11.98 11.98 0 010 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z" })
});
export default SvgSpinner;
